import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import _typeof from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var ERR_JSONP_LOAD_FAIL = -998;
var ERR_TIMEOUT = -999;
export default function (url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise(function (resolve, reject) {
    ajax(_objectSpread(_objectSpread({
      url: url,
      data: data
    }, options), {}, {
      success: resolve,
      error: function error(code, msg) {
        reject({
          code: code,
          msg: msg
        });
      }
    }));
  });
}

function ajax() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // 编码数据
  function setData() {
    // 设置对象的遍码
    function setObjData(data, parentName) {
      function encodeData(name, value, parentName) {
        var items = [];
        name = parentName === undefined ? name : parentName + '[' + name + ']';

        if (_typeof(value) === 'object' && value !== null) {
          items = items.concat(setObjData(value, name));
        } else {
          name = encodeURIComponent(name);
          value = encodeURIComponent(value);
          items.push(name + '=' + value);
        }

        return items;
      }

      var arr = [];
      var value;

      if (Object.prototype.toString.call(data) === '[object Array]') {
        for (var i = 0, len = data.length; i < len; i++) {
          value = data[i];
          arr = arr.concat(encodeData(_typeof(value) === 'object' ? i : '', value, parentName));
        }
      } else if (Object.prototype.toString.call(data) === '[object Object]') {
        for (var key in data) {
          value = data[key];
          arr = arr.concat(encodeData(key, value, parentName));
        }
      }

      return arr;
    }

    ; // 设置字符串的遍码，字符串的格式为：a=1&b=2;

    function setStrData(data) {
      var arr = data.split('&');

      for (var i = 0, len = arr.length; i < len; i++) {
        var name = encodeURIComponent(arr[i].split('=')[0]);
        var value = encodeURIComponent(arr[i].split('=')[1]);
        arr[i] = name + '=' + value;
      }

      return arr;
    }

    if (data) {
      if (typeof data === 'string') {
        data = setStrData(data);
      } else if (_typeof(data) === 'object') {
        data = setObjData(data);
      }

      data = data.join('&').replace('/%20/g', '+'); // 若是使用get方法或JSONP，则手动添加到URL中

      if (type === 'get' || dataType === 'jsonp') {
        url += url.indexOf('?') > -1 ? url.indexOf('=') > -1 ? '&' + data : data : '?' + data;
      }
    }
  } // JSONP


  function createJsonp() {
    var script = document.createElement('script');
    var timeName = new Date().getTime() + Math.round(Math.random() * 1000);
    var callback = 'JSONP_' + timeName;

    window[callback] = function (data) {
      clearTimeout(timeout_flag);
      document.body.removeChild(script);
      success(data);
    };

    script.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'callback=' + callback;
    script.type = 'text/javascript';

    script.onerror = function (e) {
      error(ERR_JSONP_LOAD_FAIL, 'error');
    };

    document.body.appendChild(script);
    setTime(callback, script);
  } // 设置请求超时


  function setTime(callback, script) {
    if (timeout !== undefined) {
      timeout_flag = setTimeout(function () {
        if (dataType === 'jsonp') {
          delete window[callback];
          document.body.removeChild(script);
        } else {
          timeout_bool = true;
          xhr && xhr.abort();
        }

        error(ERR_TIMEOUT, 'timeout');
      }, timeout);
    }
  } // XHR


  function createXHR() {
    xhr = new XMLHttpRequest();
    xhr.open(type, url, async); // 设置请求头

    if (type === 'post' && !contentType) {
      // 若是post提交，则设置content-Type 为application/x-www-four-urlencoded
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
    } else if (contentType) {
      xhr.setRequestHeader('Content-Type', contentType);
    }

    if (options.xhrFields && options.xhrFields.withCredentials) {
      xhr.withCredentials = true;
    } // 添加监听


    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (timeout !== undefined) {
          // 由于执行abort()方法后，有可能触发onreadystatechange事件，
          // 所以设置一个timeout_bool标识，来忽略中止触发的事件。
          if (timeout_bool) {
            return;
          }

          clearTimeout(timeout_flag);
        }

        if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
          success(xhr.responseText);
        } else {
          error(xhr.status, xhr.statusText);
        }
      }
    }; // 发送请求


    xhr.send(type === 'get' ? null : data);
    setTime(); // 请求超时
  }

  var url = options.url || ''; // 请求的链接

  var type = (options.type || 'get').toLowerCase(); // 请求的方法,默认为get

  var data = options.data || null; // 请求的数据

  var contentType = options.contentType || ''; // 请求头

  var dataType = options.dataType || ''; // 请求的类型

  var async = options.async === undefined ? true : options.async; // 是否异步，默认为true.

  var timeout = options.timeout; // 超时时间。

  var before = options.before || function () {}; // 发送之前执行的函数


  var error = options.error || function () {}; // 错误执行的函数


  var success = options.success || function () {}; // 请求成功的回调函数


  var timeout_bool = false; // 是否请求超时

  var timeout_flag = null; // 超时标识

  var xhr = null; // xhr对角

  setData();
  before();

  if (dataType === 'jsonp') {
    createJsonp();
  } else {
    createXHR();
  }
}